import { render } from "./ResearchFellowsDetail.vue?vue&type=template&id=5053f178"
import script from "./ResearchFellowsDetail.vue?vue&type=script&lang=js"
export * from "./ResearchFellowsDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__